/**
 * Initializes and manages product carousels
 * @function prodcarousel
 */
(function () {
  /**
   * Initializes product carousel functionality
   * @function prodcarousel
   */
  let prodcarousel = () => {
    $('.custom-product-carousel-section').each(function () {
      let slideEl = $(this).find('.product-carousel__wrapper');
      let carousel = $(this).find('.swiper-carousel');
      let slide = $(this).find('.swiper-slide');
      let buttonNext = $(this).find('.swiper-button-next');
      let prodCountHalf = parseFloat(slideEl.data('count')) - 0.2;
      if ($(this).hasClass('slider_started')) {
        return '';
      }

      $(this).addClass('slider_started');
      let id = $(this).attr('id');

      let prodSwiperParams = {
        centeredSlides: false,
        slidesPerView: 1.1,
        // waitForTransition: false,
        // watchSlidesProgress: true,
        // updateOnWindowResize: true,
        // preloadImages: true,
        allowTouchMove: true,
        spaceBetween: 20,
        breakpoints: {
          590: {
            slidesPerView: 1.5,
          },
          790: {
            slidesPerView: 2,
          },
          990: {
            slidesPerView: 2.1,
          },
          1200: {
            slidesPerView: 3.1,
          },
          1360: {
            slidesPerView: 4,
          },
        },
      };

      let swiperSlider = new Swiper(`#${id} .swiper-carousel`, {
        navigation: {
          nextEl: `#${id} .swiper-button-next__prod`,
          prevEl: `#${id} .swiper-button-prev__prod`,
        },
        ...prodSwiperParams,
      });
    });
  };

  // Event listeners for carousel initialization
  document.addEventListener('DOMContentLoaded', function () {
    prodcarousel();
  });

  document.addEventListener('shopify:section:load', function () {
    prodcarousel();
  });

  document.addEventListener('resize', function () {
    prodcarousel();
  });

  document.addEventListener('visibilitychange', function () {
    prodcarousel();
  });

  prodcarousel();
})();
